import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Toast } from '../interfaces/toast';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  toasts$ = new BehaviorSubject<Toast[]>([]);

  addToast(toast: Toast): void {
    this.toasts$.next([...this.toasts$.getValue(), toast]);
    setTimeout(() => this.removeToast(toast), 7500);
  }

  removeToast(toast: Toast): void {
    const toasts = this.toasts$.getValue();
    toasts.splice(toasts.indexOf(toast));
    this.toasts$.next(toasts);
  }
}
